import app from 'flarum/forum/app';

import config from '../common/config';
import setupIframe from './setupIframe';
import setupAdmin from './setupAdmin';
import setupMall from './setupMall';
import addPointsRanking from './addPointsRanking';
import addUserPointDetails from './addUserPointDetails';

export { default as extend } from './extend';

app.initializers.add(config.module.key, () => {
  setupIframe();
  setupAdmin();
  setupMall();
  addPointsRanking();
  addUserPointDetails();
});
